export default __webpack_public_path__ + "static/media/Banner_VismaPay_payment_methods.d2103046.png";